// extracted by mini-css-extract-plugin
module.exports = {"input":"MoneyInput_input__1rqtd"};